export const SIGN_IN_ENDPOINT = 'user/signin';
export const AUTH_SIDEBAR_ENDPOINT = 'user/authsidebar';
export const USER_AUTH = 'user/auth';
export const USER_AUTH_PDL = 'user/authpdl';
export const USER_FORGET_PDW = 'user/forgetpwd';
export const USER_RESET_PDW = 'user/reset';
